import React, { createContext, useContext, useState, ReactNode } from 'react';

import { LastCreditAlertContent } from 'utils/last-credit-alert';

interface LastCreditAlertContextType {
  showRenewalNotification: (alert: LastCreditAlertContent) => void;
  hideRenewalNotification: () => void;
  renewalNotification: LastCreditAlertContent | null;
}

const LastCreditAlertContext = createContext<LastCreditAlertContextType | undefined>(undefined);

interface LastCreditAlertProviderProps {
  children: ReactNode;
}

export const LastCreditAlertProvider = ({ children }: LastCreditAlertProviderProps): JSX.Element => {
  const [renewalNotification, setRenewalNotification] = useState<LastCreditAlertContent | null>(null);

  const showRenewalNotification = (alert: LastCreditAlertContent): void => {
    setRenewalNotification(alert);
  };

  const hideRenewalNotification = (): void => {
    setRenewalNotification(null);
  };

  return (
    <LastCreditAlertContext.Provider
      value={{
        showRenewalNotification,
        hideRenewalNotification,
        renewalNotification,
      }}
    >
      {children}
    </LastCreditAlertContext.Provider>
  );
};

export const useLastCreditAlert = (): LastCreditAlertContextType => {
  const context = useContext(LastCreditAlertContext);
  if (!context) {
    throw new Error('useLastCreditAlert must be used within a LastCreditAlertProvider');
  }
  return context;
};
